import { twMerge } from "tailwind-merge";

export function Card({
  children,
  header,
  className,
}: {
  children: React.ReactNode;
  header?: React.ReactNode;
  className?: string;
}) {
  const headerElement = header ? <CardHeader>{header}</CardHeader> : null;

  const bodyElement = children ? <CardBody>{children}</CardBody> : null;

  return (
    <div
      className={twMerge(
        "bg-white dark:bg-zinc-800 shadow dark:shadow-zinc-950/30 rounded-lg overflow-hidden dark:border dark:border-zinc-700 dark:text-zinc-100",
        className
      )}
    >
      {headerElement}
      {bodyElement}
    </div>
  );
}

export function CardHeader({ children }: { children: React.ReactNode }) {
  return (
    <div className="px-4 py-5 sm:p-6 border-b border-gray-200 dark:border-zinc-700">
      {children}
    </div>
  );
}

export function CardBody({ children }: { children: React.ReactNode }) {
  return <div className="px-4 py-5 sm:p-6 space-y-4">{children}</div>;
}
